import { Feature } from '@/pinia/feature'
import { buildingScore2 } from '../analytics/buildingScore2'

export const wip: Feature = {
  name: 'wip',
  enabled: true,
  access: ['ROLE_ADMIN'],
  title: {
    en: 'Work in progress',
    sv: 'Work in progress'
  },
  component: 'FeatureCard',
  isRoute: true,
  props: {
    icon: 'IconTruck',
    disableIsDrawPointActive: true
  },
  children: [
    {
      name: 'wip',
      enabled: true,
      title: {
        en: 'WIP',
        sv: 'WIP'
      },
      component: 'FeatureCard',
      props: {
        icon: 'IconTimeLine',
        disableIsDrawPointActive: true
      },
      children: [buildingScore2]
    }
  ]
}
